import { GenericInfoScreen } from './GenericInfoScreen';
import { Onboarding10Pillars } from './Onboarding10Pillars';
import { OnboardingComplete } from './OnboardingComplete';
import { OnboardingPillarsRevealed } from './OnboardingPillarsRevealed';
import { OnboardingScores } from './OnboardingScores';
import type { CustomScreenComponent } from './types';

const registry: Record<string, CustomScreenComponent> = {
  info: GenericInfoScreen,
  default: GenericInfoScreen,
  onboardComplete: OnboardingComplete,
  tenPillars: Onboarding10Pillars,
  tenPillarsRevealed: OnboardingPillarsRevealed,
  onboardScores: OnboardingScores
};

export const registerCustomScreen = (screenType: string, component: CustomScreenComponent) => {
  registry[screenType] = component;
};

export const getCustomScreenComponent = (screenType?: string): CustomScreenComponent | null => {
  if (!screenType) {
    return registry.default ?? null;
  }
  return registry[screenType] ?? registry.default ?? null;
};

export type { CustomScreenComponentProps } from './types';
export { GenericInfoScreen };
